
const getLanguage = (locale) => {
  switch (locale) {
    case 'ja':
      return '日本語';
    case 'es':
      return 'Español';
    case 'pt':
      return 'Português';
    case 'fr':
      return 'Français';
    default:
      return 'English';
  }
};

export default getLanguage;
